import { render, staticRenderFns } from "./djggg.vue?vue&type=template&id=5db28fb0&scoped=true&"
import script from "./djggg.vue?vue&type=script&lang=js&"
export * from "./djggg.vue?vue&type=script&lang=js&"
import style0 from "./djggg.vue?vue&type=style&index=0&id=5db28fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db28fb0",
  null
  
)

export default component.exports